// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3cNhJ","content":"styles_content__1R2Or","checkbox":"styles_checkbox__3oA4N","checkboxLabel":"styles_checkboxLabel__WjfFW"};